export default "__VITE_ASSET__cadf020d__"